import React, { Component } from 'react';
import isEqual from 'lodash/isEqual';
import DropdownTreeSelect from 'react-dropdown-tree-select';
import 'react-dropdown-tree-select/dist/styles.css';

export default class DropdownContainer extends Component {
    constructor(props) {
        super(props);
        this.state = { data: props.data };
    }

    //componentWillReceiveProps
    componentWillReceiveProps = (nextProps) => {
        if (!isEqual(nextProps.data, this.state.data)) {
            this.setState({ data: nextProps.data });
        }
    };

    //shouldComponentUpdate
    shouldComponentUpdate = (nextProps) => {
        return !isEqual(nextProps.data, this.state.data);
    };

    render() {
        const { data, ...rest } = this.props;
        return (
            <DropdownTreeSelect
                texts={{ placeholder: 'Search level3 or students' }}
                data={this.state.data}
                clearSearchOnChange={true}
                showPartiallySelected={true}
                {...rest}
            />
        );
    }
}
